import { RequestFactory } from '../../api/RequestFactory';
import queryString = require('query-string');
import { apiUrl, pmApiUrl } from '../../api/config';

const suFactory = new RequestFactory(pmApiUrl);
const apiFactory = new RequestFactory(`${apiUrl}/3`);

const apiKey = queryString.parse(location.search).apiKey;

if (apiKey) {
    suFactory.setApiKey(apiKey);
    apiFactory.setApiKey(apiKey);
}

export default suFactory;
export { apiFactory };



// WEBPACK FOOTER //
// ./src/actions/su/requestFactory.ts